module.exports = __webpack_public_path__ + "static/media/team-img4.54252c3f.jpg";